export const HAKLAI_ANOTHER_QUESTIONS_LABELS = Object.freeze({
  sectionTitle: "שאלות נוספות",
  businessLossOffset: "קיזוז הפסד עסקי",
  capitalLossOffset: "קיזוז הפסד הוני",
  taxGrossUp: "חישוב המס בדרך של גילום",
  expropriationCredit: "האם יש זיכוי הפקעה",
  yes: "כן",
  no: "לא"
});

export const HAKLAI_ANOTHER_QUESTIONS_ERRORS = Object.freeze({
  prisaAndGrossUpConflict: "לא ניתן לעשות פריסה וגילום ביחד"
});
